import { customColors } from "models/customColors";
import React from "react";

const ConditionalBoldText = ({ text, row }) => {
  return (
    <span style={row?.status === "New" ? { fontWeight: "bold", color: customColors.newReferral } : {}}>
      {text}
    </span>
  );
};

export default ConditionalBoldText;
